import { fetch } from '@/commons/fetch'
const getData = ({ type, indicatorId, lastDate, offset }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: 'https://calendar-api.ushknews.com/getWebTargetPriceList',
      type: 'get',
      useJson: true,
      headers: {
        'x-version': '1.0.0',
        'x-app-id': 'BNsiR9uq7yfW0LVz'
      },
      params: {
        limit: 20,
        category: type,
        indicator_id: indicatorId,
        date: lastDate,
        offset
      },
      callback: (res) => {
        resolve(res)
      },
      error: () => {
        reject()
      }
    })
  })
}

export default getData



// WEBPACK FOOTER //
// ./src/views/report/modules/getData.js